<template>
  <div class="card-carousel-wrapper">
    <template v-if="!isSolidArrow">
      <!-- <div class="card-carousel--nav__left" @click="moveCarousel(-1)" :disabled="atHeadOfList"></div> -->
      <div class="arrow_left" @click="moveCarousel(-1)" :disabled="atHeadOfList" v-show="!atHeadOfList">
        <img src="../../assets/icon/arrow.png" class="arrow_img" />
      </div>
    </template>
    <template v-else>
      <!-- <div class="left_solid_arrow" @click="moveCarousel(-1)" :disabled="atHeadOfList"></div> -->
      <div class="arrow_left" @click="moveCarousel(-1)" :disabled="atHeadOfList" v-show="!atHeadOfList">
        <img src="../../assets/icon/arrow.png" class="arrow_img" />
      </div>
    </template>

    <template v-if="cardCarousel">
      <div class="card-carousel" :style="{width: cardCarousel + 'px'}">
        <div class="card-carousel--overflow-container">
          <div
            class="card-carousel-cards"
            :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}"
          >
            <slot></slot>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="card-carousel">
        <div class="card-carousel--overflow-container">
          <div
            class="card-carousel-cards"
            :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}"
          >
            <slot></slot>
          </div>
        </div>
      </div>
    </template>
    <template v-if="!isSolidArrow">
      <!-- <div class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList"></div> -->
      <div class="arrow_right" @click="moveCarousel(1)" :disabled="atHeadOfList" v-show="!atEndOfList">
        <img src="../../assets/icon/arrow.png" class="arrow_img" />
      </div>
    </template>
    <template v-else>
      <!-- <div class="right_solid_arrow" @click="moveCarousel(1)" :disabled="atEndOfList"></div> -->
      <div class="arrow_right" @click="moveCarousel(1)" :disabled="atHeadOfList" v-show="!atEndOfList">
        <img src="../../assets/icon/arrow.png" class="arrow_img" />
      </div>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentOffset: 0,
    };
  },
  computed: {
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor * -1 * (this.len - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  props: [
    "len",
    "paginationFactor",
    "cardCarousel",
    "windowSize",
    "isSolidArrow",
  ],
  created() {
    this.imgIndex = this.dotsIndex = this.initIndex;
    this.durationTime = this.duration;
    if (this.auto) this.autoPlay();
  },
  methods: {
    moveCarousel(direction) {
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
  },
};
</script>
<style lang='scss'>
@import "../../style/color";
.card-carousel-wrapper {
  position: relative;
}
.arrow_left{
  position: absolute;
  left: -40px;
  top: 150px;
}
.arrow_right{
  position: absolute;
  right: -40px;
  top: 150px;
}
.arrow_right .arrow_img,.arrow_left .arrow_img{
  width: 19px;
  height: 26px;
}
.arrow_right .arrow_img{
  transform:rotate(180deg)
}
.card-carousel {
  display: flex;
  justify-content: left;
  overflow: hidden;
  width: 1050px;
  box-sizing: border-box;
}
.card-carousel--overflow-container {
  overflow: hidden;
}
.left_solid_arrow,
.right_solid_arrow {
  display: inline-block;
  width: 15px;
  height: 15px;
  // padding: 10px;
  box-sizing: border-box;
  border-top: 2px solid #42b883;
  border-right: 2px solid #42b883;
  cursor: pointer;
  margin: 0 10px;
  position: absolute;
  transition: transform 150ms linear;
}
.left_solid_arrow[disabled],
.right_solid_arrow[disabled] {
  opacity: 0.2;
  // border-color: black;
}
.left_solid_arrow {
  position: absolute;
  cursor: pointer;
  left: -50px;
  top: 30px;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: transparent #000 transparent transparent;
}
.right_solid_arrow {
  position: absolute;
  cursor: pointer;
  right: -50px;
  top: 30px;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent transparent #000;
}
.card-carousel--nav__left,
.card-carousel--nav__right {
  display: inline-block;
  width: 15px;
  height: 15px;
  padding: 10px;
  box-sizing: border-box;
  border-top: 2px solid #42b883;
  border-right: 2px solid #42b883;
  cursor: pointer;
  margin: 0 10px;
  position: absolute;
  transition: transform 150ms linear;
}
.card-carousel--nav__left[disabled],
.card-carousel--nav__right[disabled] {
  opacity: 0.2;
  border-color: black;
}
.card-carousel--nav__left {
  transform: rotate(-135deg);
  left: -44px;
  top: 50%;
  margin-top: -7.5px;
}
.card-carousel--nav__left:active {
  transform: rotate(-135deg) scale(0.9);
}
.card-carousel--nav__right {
  transform: rotate(45deg);
  right: -44px;
  top: 50%;
  margin-top: -7.5px;
}
.card-carousel--nav__right:active {
  transform: rotate(45deg) scale(0.9);
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
}
.card-carousel-cards .card-carousel--card {
  margin: 0 10px;
  cursor: pointer;
  box-shadow: 0 4px 15px 0 rgba(40, 44, 53, 0.06),
    0 2px 2px 0 rgba(40, 44, 53, 0.08);
  background-color: #fff;
  border-radius: 4px;
  z-index: 3;
  margin-bottom: 2px;
}
.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}
.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}
.card-carousel-cards .card-carousel--card img {
  vertical-align: bottom;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: opacity 150ms linear;
  user-select: none;
}
.card-carousel-cards .card-carousel--card img:hover {
  opacity: 0.5;
}
.card-carousel-cards .card-carousel--card--footer {
  border-top: 0;
  padding: 7px 15px;
}
.card-carousel-cards .card-carousel--card--footer p {
  padding: 3px 0;
  margin: 0;
  margin-bottom: 2px;
  font-size: 19px;
  font-weight: 500;
  color: #2c3e50;
  user-select: none;
}
.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2) {
  font-size: 12px;
  font-weight: 300;
  padding: 6px;
  background: rgba(40, 44, 53, 0.06);
  display: inline-block;
  position: relative;
  margin-left: 4px;
  color: #666a73;
}
.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):before {
  content: "";
  float: left;
  position: absolute;
  top: 0;
  left: -12px;
  width: 0;
  height: 0;
  border-color: transparent rgba(40, 44, 53, 0.06) transparent transparent;
  border-style: solid;
  border-width: 12px 12px 12px 0;
}
.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):after {
  content: "";
  position: absolute;
  top: 10px;
  left: -1px;
  float: left;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: white;
  box-shadow: -0px -0px 0px #004977;
}

h1 {
  font-size: 3.6em;
  font-weight: 100;
  text-align: center;
  margin-bottom: 0;
  color: #42b883;
}
</style>


// WEBPACK FOOTER //
// src/components/public/hCarousel.vue